// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import axios from './apis/index.js'
import PageCachePlugin from './plugins/PageCachePlugin'
import formatDatePlugin from './plugins/DateFormatPlugin'
import formatAmountPlugin from './plugins/AmountFormatPlugin'
import keywordHeightLightPlugin from './plugins/KeywordHeightLight'
import FunctionAuthorizePlugin from './plugins/FunctionAuthorizePlugin'
import DictionaryPlugin from './plugins/DictionaryPlugin'
import NumberFormat from './plugins/NumberFormat'
import MoneyFormat from './plugins/MoneyFormat'
import './assets/css/vue-draggable-resizable.css'
import 'lib-flexible' // rem适配
import MintUI from 'mint-ui'
import ElementUI from 'element-ui'
import '@/assets/fonts/iconfont.css'

import ECharts from 'vue-echarts'

import 'echarts/lib/chart/line'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/radar'
import 'echarts/lib/chart/candlestick' // K线图
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/axisPointer'
import 'echarts/lib/component/grid'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/markPoint'
import 'echarts/lib/component/markLine'
import 'echarts/lib/component/markArea'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legendScroll'
import 'echarts/lib/component/dataZoom'
import 'wangeditor/release/wangEditor.css'
import Viewer from 'v-viewer/dist/v-viewer'
import 'viewerjs/dist/viewer.css'
import elTableInfiniteScroll from 'el-table-infinite-scroll' // el-table 使用无限滚动加载
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import 'videojs-flash'
import 'videojs-contrib-hls'
import streamMediaVideo from './components/StreamMediaVideo.vue'
import streamMediaAudio from './components/StreamMediaAudio.vue'

Vue.component('v-chart', ECharts)
Vue.use(Viewer)

Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
Vue.use(elTableInfiniteScroll)
Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(PageCachePlugin)
Vue.use(formatDatePlugin)
Vue.use(formatAmountPlugin)
Vue.use(keywordHeightLightPlugin)
Vue.use(FunctionAuthorizePlugin)
Vue.use(DictionaryPlugin)
Vue.prototype.axios = axios
Vue.prototype.eCharts = ECharts
Vue.use(MintUI)
Vue.use(NumberFormat)
Vue.use(MoneyFormat)
Vue.use(ElementUI)
Vue.use(VideoPlayer)

Vue.component('stream-media-video', streamMediaVideo)
Vue.component('stream-media-audio', streamMediaAudio)

// 主动触发日历的今日高亮 主动触发当前日期的点击pick

Vue.prototype.globalClick = function (callback) {
  document.getElementById('app').onclick = function () {
    callback()
  }
}

/* eslint-disable no-new */
window.globalVue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js